<template>
  <div id="app">
    <Navbar></Navbar>
    <loader v-if="loaderShow"></loader>
    <div>
      <visualizeTable @updateIt="updateIt(...arguments)" v-if="step == 1"></visualizeTable>
      <div v-if="step == 2">
        <div class="row mt-4 justify-content-center">
          <div class="col-sm-12 p-5 m-5 col-md-6 card">
            <h2 class="mb-4">Start Data Analysis</h2>
              <label class="text-left mb-2 ml-2">Enter Project Name</label>
              <input type="text" class="inputSty" placeholder="" v-model="pName" />
            <div class="fields fields text-center my-4 py-3 my-4">
              <button
                class="button downloadButton"
                style="width: 50%"
                @click="giveNameToProject"
              >Start</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step == 3">
        <div class="row mt-4 justify-content-center">
          <div class="card col-sm-12 col-md-8 pt-4 py-5 mt-5 col-8">
            <h2>Upload Your CSV file</h2>

            <form @submit.prevent="onSubmit" enctype="multipart/form-data">
              <div class="button_outer mx-auto my-5">
                <div class="fields">
                  <label class="mt-3">Upload CSV File</label>
                  <br />
                  <input type="file" ref="file" class="inputClass" accept=".csv" @change="onSelect" />
                </div>
              </div>
              <div>
                <p v-if="fileName != ''|| fileName != ' '">{{fileName}}</p>
              </div>
              <div class="fields my-4">
                <button class="button">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-if="step == 4">
        <div class="mt-5">
          <h2 class="text-center">Select Options</h2>
          <div class="row">
            <div class="col-sm-12 text-left col-md-6 px-5 py-4">
              <label class="ml-2 mb-2">Select Numerical Feature</label>
              <div class="d-flex">
                <multiselect
                  class="multi"
                  v-model="numerical"
                  :multiple="true"
                  placeholder="Please Select"
                  :options="modelTrainKeys"
                ></multiselect>
              </div>
            </div>
            <div class="col-sm-12 text-left col-md-6 px-5 py-4">
              <label class="ml-2 mb-2">Select categorical Feature</label>
              <div class="d-flex">
                <multiselect
                  class="multi"
                  v-model="categorical"
                  :multiple="true"
                  placeholder="Please Select"
                  :options="modelTrainKeys"
                ></multiselect>
              </div>
            </div>
            <div class="col-sm-12 text-left col-md-6 px-5 py-4">
              <label class="ml-2 mb-2">Select datetime Feature</label>
              <div class="d-flex">
                <multiselect
                  class="multi"
                  v-model="datetime"
                  :multiple="true"
                  placeholder="Leave Empty if Not Applicable"
                  :options="modelTrainKeys"
                ></multiselect>
              </div>
            </div>
            <div class="col-sm-12 text-left col-md-6 py-4 px-5">
              <label class="ml-2 mb-2">Frequency</label><br />
              <select v-model="frequency" class="selectC">
                <option v-for="(fr, i) in frequencyType" :value="fr" :key="i">{{i}}</option>
              </select>
            </div>
            <div class="fields fields my-4 col-sm-12 col-12 pr-5 my-4">
              <button class="button" style="width: 9rem" @click="validateModel()">Analyze</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import logo from '../assets/Logo_Final.png';
import visualizeTable from "./visualizeComponent/visualizeTable";
import Toasted from "vue-toasted";
import Vue from "vue";
import $ from "jquery";
import loader from "./loader";
import "vue2-datepicker/index.css";
import { apiCall } from "@/utils/api";
import Navbar from "./navbar";
import axios from "axios";
import multiselect from "vue-multiselect";

Vue.use(Toasted);

export default {
  name: "Visualize",
  props: {
    msg: String
  },
  components: {
    visualizeTable: visualizeTable,
    loader: loader,
    Navbar: Navbar,
    multiselect: multiselect
  },
  data() {
    return {
      price: 5000,
      uploadFileDetails: {},
      frequencyType: {"1 Hour": "H", "Daily": "D", "Monthly": "M", "Yearly": "Y"},
      frequency: 'H',
      modelTrainKeys: [],
      datetime: [],
      categorical: [],
      numerical: [],
      fileName: "",
      pName: "",
      loaderShow: false,
      step: 1,
      modelInfo: {},
      file: "",
      user: JSON.parse(localStorage.getItem('user'))
    };
  },
  watch: {
    categorical(newVal, oldVal) {
      this.updateInfo(newVal, oldVal)
    },
    numerical(newVal, oldVal) {
      this.updateInfo(newVal, oldVal)
    },
    datetime(newVal, oldVal) {
      this.updateInfo(newVal, oldVal)
    }
  },
  mounted() {
    $(".multiselect__select").attr("style", "height: 34px !important");
    $(".multiselect__placeholder").attr(
      "style",
      "margin-bottom: 3px !important; padding-top: 0px !important; color: #555 !important"
    );
    $(".multiselect__tags").attr(
      "style",
      "min-height: 34px !important;color: #555 !important; font-size: 14px !important; padding-top: 6px !important; padding-left: 10px !important; line-height: 1.4 !important; padding-bottom: 6px !important"
    );
  },
  computed: {},
  methods: {
    updateInfo(newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        let intersection1 = newVal.filter(x => !oldVal.includes(x))[0];
        let index = this.modelTrainKeys.indexOf(intersection1)
        this.modelTrainKeys.splice(index, 1)
      } else {
        let intersection2 = oldVal.filter(x => !newVal.includes(x))[0];
        this.modelTrainKeys.push(intersection2)
      }
    },
    validateModel() {
      this.loaderShow = true;
      const url = `visual_ml/ValidateFile/${this.modelInfo._id}`
      const body = {
        bucket_name: this.uploadFileDetails['Bucket'],
        filename: this.uploadFileDetails['Key'],
        project_name: this.modelInfo['project_name'],
        numerical: this.numerical,
        categorical: this.categorical,
        datetime: this.datetime,
        visualId: this.modelInfo._id,
        userId: this.modelInfo['userId']
      };
      // console.log('body is here jgjgh', body, this.uploadFileDetails)
      apiCall({url, data: body, method: "put"})
          .then((r) => {
            let warning = r.data
            // console.log('warning is here', r)
            if(warning['datetime'].length > 0) {
              Swal.fire({
                title: 'Warning',
                text: `please select correct date time column`,
                type: 'warning'
              })
              this.loaderShow = false
            } else if(warning['categoric'].length > 0 || warning['numeric'].length > 0) {
              let str = ' Chosen feature might not be correct'
              if (warning['categoric'].length > 0) {
                str = str.concat(' categorical: ')
                Object.keys(warning['categoric']).map((key) => {
                  str = str.concat(warning['categoric'][key] + ', ')
                  return true
                })
              }
              if (warning['numeric'].length > 0) {
                str = str.concat(' numerical: ')
                Object.keys(warning['numeric']).map((key) => {
                  str = str.concat(warning['numeric'][key]+ ', ')
                  return true
                })
              }
              Swal.fire({
                title: 'Warning',
                text: `${str}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Continue',
              }).then((result) => {
                if (result.value) {
                  this.UpdateModelInfo()
                } else if (result.dismiss) {
                  this.loaderShow = false
                }
              })
            } else if (warning['datetime'].length === 0 && warning['categoric'].length === 0 && warning['numeric'].length === 0) {
              this.UpdateModelInfo()
            }
          }).catch((err)=>{
            console.log('error', err)
          })
    },
    UpdateModelInfo() {
      this.loaderShow = true;
      const datetime = this.datetime,
        categorical = this.categorical,
        numerical = this.numerical,
        timeInterval = this.frequency;
      const body = { datetime, categorical, numerical, timeInterval };
      const url = `visual_ml/${this.modelInfo._id}`;
      apiCall({ url, data: body, method: "put" })
        .then(() => {
          this.step = 1;
          this.loaderShow = false;
        })
        .catch(err => {
          console.log("error", err);
          this.loaderShow = false;
        });
    },
    onSelect() {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      const file = this.$refs.file.files[0];
      this.file = file;
      this.fileName = this.$refs.file.files[0].name;
      if (!allowedTypes.includes(file.type)) {
        this.message = "Filetype is wrong!!";
      }
      if (file.size > 500000) {
        this.message = "Too large, max size allowed is 500kb";
      }
    },
    async onSubmit() {
      this.loaderShow = true;
      const formData = new FormData();
      formData.append("file", this.file);
      try {
        const token = localStorage.getItem("user-token") || "";
        if (token) {
          axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        }
        await axios
          .post(
            `https://automl-api.getambee.com/visual_ml/uploadFile/${this.modelInfo._id}/${this.modelInfo.project_name}`,
            formData
          )
          .then(r => {
            this.modelTrainKeys = r.data.keys;
            this.uploadFileDetails = r.data.data;
            this.step = 4;
            this.loaderShow = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    getpayment() {
      const options = {
        key: 'rzp_live_J4PaDX6yFUjDFR',
        // amount: 5000,
        name: 'Ambee',
        currency: 'INR',
        description: `subsribe for one month`,
        image: logo,
        handler: (response) => {
          this.verifySignature(response)
        },
        prefill: {
          name: JSON.parse(localStorage.getItem('user')).name,
          email: JSON.parse(localStorage.getItem('user')).email,
        },
        notes: {
          address: JSON.parse(localStorage.getItem('user')).address,
        },
        theme: {
          color: '#2295C8',
        },
      }
      const url = 'payment/order'
      const body = {
        amount: this.price * 100,
        email: JSON.parse(localStorage.getItem('user')).email,
      }
      apiCall({ url, data: body, method: 'post' })
        .then((res) => {
          // console.log('res is here', res)
          this.loaderShow = false
          /* eslint-disable */
          const rzp1 = new Razorpay({ ...options, order_id: res.orderId })
          rzp1.open()
        })
        .catch((err) => { console.log('ERR', err) })
    },
    verifySignature(response) {
      this.loaderShow = true
      const url = 'payment/confirmPayment'
      apiCall({ url, data: { payment: response }, method: 'post' }).then((res) => {
        // delete res.userUpdated._id;
        // delete res.userUpdated.password;
        localStorage.setItem('user', JSON.stringify(res.userUpdated))
        localStorage.setItem('user-token', res.token);
        this.user = res.userUpdated;
        this.loaderShow = false
        Swal.fire({
          title: 'Awesome !',
          text: 'payment successfully !',
          type: 'success',
        })
      }).catch((err) => {
        console.log('error', err)
      })
    },
    giveNameToProject() {
      if (this.pName === "" || this.pName === " ") {
        this.$toasted.show("please give model name", { duration: 1000 });
        return;
      }
      const url = `visual_ml`;
      this.loaderShow = true;
      const body = {
        project_name: this.pName
      };
      apiCall({ url, data: body, method: "post" })
        .then(resp => {
          this.modelInfo = resp.data;
          this.step = 3;
          this.loaderShow = false;
        })
        .catch(err => {
          if (err.message === 'Request failed with status code 301') {
            Swal.fire({
              title: "Only Paid Service",
              text: `Please make payment`,
              type: "success",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Start Payment"
            }).then(result => {
              if (result.value) {
                this.getpayment()
                this.step = 1
              } else {
                this.step = 1
              }
            });
          }
          this.loaderShow = false;
        });
    },
    updateIt(count) {
      if (count === 2) {
        if (this.user.payment) {
          this.step = count
        } else {
          Swal.fire({
            title: "Only Paid Service",
            text: `Please make payment`,
            type: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Start Payment"
          }).then(result => {
            if (result.value) {
              this.getpayment()
              this.step = 1
            } else {
              this.step = 1
            }
          });
        }
      } else {
        this.step = count;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.downloadButton {
  width: 20rem;
  height: 5rem;
}
.selectC {
  background: white;
  border: 1px solid #e8e8e8;
  color: #555;
  border-radius: 6px;
  min-height: 34px;
  font-size: 14px;
  padding-top: 6px;
  padding-left: 10px;
  line-height: 1.4;
  padding-bottom: 6px;
}
.inputSty {
  min-height: 34px;
  color: #555;
  font-size: 14px;
  padding-top: 6px;
  padding-left: 10px;
  line-height: 1.4;
  padding-bottom: 6px;
  width: 86%;
  padding-left: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.logoutFont {
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
.multi {
  /* z-index: 99; */
  height: auto;
  width: 80% !important;
}

.details {
  color: white;
}
/*custom font*/

/* @primary-color: #63a2cb; */
/* @#67d5bf: #67d5bf; */
/*basic reset*/
* {
  margin: 0;
  padding: 0;
}

html {
  height: 100%;
  background: #0e0e0e;
}

body {
  font-family: "Open Sans", arial, verdana;
}
/*headings*/
.fs-title {
  font-size: 16px;
  text-transform: uppercase;
  color: #63a2cb;
  margin-bottom: 10px;
}
.fs-subtitle {
  font-weight: normal;
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.help-block {
  font-size: 0.8em;
  color: #7c7c7c;
  text-align: left;
  margin-bottom: 0.5em;
}
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

select {
  height: 34px !important;
  width: 80% !important;
}

a.button {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  padding: 0;
  margin: 10px 20px 10px 0;
  font-weight: 600;
  text-align: center;
  line-height: 50px;
  color: #fff;
  border-radius: 5px;
  transition: all 0.2s;
}

a,
a:visited {
  text-decoration: none;
  color: white !important;
}
.button {
  width: 6rem;
  height: 3rem;
  /* margin: 1rem; */
  border: 1px solid blue;
  color: white;
  background: cadetblue;
  /* padding: 1rem; */
  border-radius: 20px;
}
.button_outer {
  background: #83ccd3;
  border-radius: 30px;
  text-align: center;
  height: 50px;
  width: 200px;
  display: inline-block;
  transition: 0.2s;
  position: relative;
  overflow: hidden;
}
.btn_upload {
  padding: 17px 30px 12px;
  color: #fff;
  text-align: center;
  position: relative;
  display: inline-block;
  overflow: hidden;
  z-index: 3;
  white-space: nowrap;
}
.inputClass {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  width: 100%;
  height: 105%;
  cursor: pointer;
  opacity: 0;
}
</style>
